import { useCallback, useEffect, useState } from 'react';
import { rpc, type AppError, type Forecast, type TeacherHomeData } from './api';

export function useTeacherHome() {
  const [data, setData] = useState<TeacherHomeData | null>(null);
  const [error, setError] = useState<AppError | null>(null);
  const load = useCallback(async () => {
    const r = await rpc<TeacherHomeData>('teacher_home');
    if (r.error) setError(r.error);
    else {
      setError(null);
      setData(r.data);
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  return { data, error, reload: load };
}

export function forecastPill(f: Forecast): 'good' | 'warn' | 'crit' | 'neutral' {
  return f === 'likely' ? 'good' : f === 'uncertain' ? 'warn' : f === 'unlikely' ? 'crit' : 'neutral';
}

